export default {
  'SET_INTEGRATIONS'(state, data) {
    state.integrations = data;
  },
  'REPLACE_INTEGRATION'(state, data) {
    state.integrations = state.integrations.map(item => {
      if (parseInt(item.id) === parseInt(data.id)) {
        return data;
      }

      return item;
    });
  },
  'SET_DISCOVERED_DEVICES'(state, data) {
    state.discoveredDevices = data;
  },
  'SET_QUERY_LOCATION_RESPONSE'(state, data) {
    state.queryLocationResponse = data;
  }
};